// extracted by mini-css-extract-plugin
export default {"img-cover":"SignIn_img-cover__1WbeA"};